import React, { useState, useEffect, useRef } from 'react';
import { Wrapper } from './styled';
import { NavBar } from '@app/src/common/header';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();
const TABLET_LANDSCAPE: number = 768;

export const HeaderResponsive: React.FC = () => {
  const headerRef = useRef(null);
  const [ headerHeight, setHeaderHeight ] = useState(0);

  useEffect(() => {
    headerRef && setHeaderHeight(headerRef.current.offsetHeight);
  });

  const milestones = {};
  const [ isShow, setIsShow ] = useState(false);

  useEffect(() => {
    if(isClient) {
      window.addEventListener('load', handleHeaderFixed)
      window.addEventListener('scroll', handleHeaderFixed);
      setElementsByScrolling();
      return () => {
        window.removeEventListener('scroll', handleHeaderFixed);
        window.removeEventListener('load', handleHeaderFixed);
      };
    }
  });

  const setElementsByScrolling = (): void => {
    const arrMilestones = document.querySelectorAll('[data-scroll]');
    for (let i=0; i < arrMilestones.length; i++) {
      const dataScroll = arrMilestones[i].getAttribute('data-scroll');
      milestones[dataScroll] = arrMilestones[i];
    }
  };

  const handleHeaderFixed = () => {
    const isMobileDevice: boolean = window.innerWidth < TABLET_LANDSCAPE;
    const isHomeSection: boolean = window.pageYOffset < getOffsetTop('inmueble');
    const isAnotherSection: boolean = window.pageYOffset >= getOffsetTop('inmueble');

    if (isMobileDevice) {
      if(isHomeSection) {
        setIsShow(false);
        document.body.style.paddingTop = '0px';
      }
      if (isAnotherSection) {
        setIsShow(true);
        document.body.style.paddingTop = `${headerHeight}px`;
      }
    }
  };

  const getOffsetTop = (section:string): number => {
    return milestones[section]['offsetTop'];
  };

  return(
    <Wrapper ref={headerRef} isShow={isShow}>
      <NavBar />
    </Wrapper>
  );
};

HeaderResponsive.displayName = 'HeaderResponsive';
